<template lang="pug">
    ul.dropdown-menu
      template(v-for="(n, index) in node.children")
        li(:class="{'dropdown-submenu': n.children }")
          a(@click="$emit('itemClick', aggregatePath(node, n.label))") {{ n.label }}
            .right.caret(v-if="n.children")
          ToolbarDropdownTree(:node="n" :key="index" v-if="n.children" @itemClick="bubbleUp")
</template>

<script>
export default {
  name: 'ToolbarDropdownTree',
  props: {
    node: {
      type: Object,
      required: false
    }
  },
  methods: {
    aggregatePath(parentNode, path) {
      return `${parentNode.label}.${path}`
    },
    bubbleUp(path) {
      this.$emit('itemClick', this.aggregatePath(this.node, path))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/ToolbarDropdownTree.vue